// layout
import LayoutLogin from "../Container/Layout/LayoutLogin";
// style
import styles from "../Styles/Authentication/Login.module.css";
// component
import BtnBack from "../Components/Authentication/BtnBack";
import { Context } from "../Context/Context";
import { useContext, useEffect } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { RegisterSchema } from "../Components/Validations/Validation";
import { register } from "../Services/ContectService";
import { toast } from "react-toastify";

const Register = () => {

    const { json, numberconvert, setPhoneNum, showPasswordInput, setLoading } = useContext(Context);
    const content = json?.Register;
    let navigate = useNavigate();

    const registerHandeler = async (values) => {
        setLoading(true);
        values.phone_number = numberconvert(values.phone_number);
        values.password = numberconvert(values.password);
        values.confirm_password = numberconvert(values.confirm_password);
        try {
            const { status } = await register(values);
            if (status === 201) {
                setLoading(false);
                toast.success(json.toast.login_5);
                setPhoneNum(values.phone_number);
                return navigate("/verification");
            }
        } catch (error) {
            if (error?.response?.status === 400) {
                toast.error(json.toast.login_3);
                setLoading(false);
                return navigate("/login");
            } else {
                toast.error(json.toast.err_1);
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        showPasswordInput();
    }, [])


    return (
        <LayoutLogin>
            <Formik
                initialValues={{
                    name: "",
                    family: "",
                    phone_number: "",
                    email: "",
                    password: "",
                    confirm_password: ""
                }}
                validationSchema={RegisterSchema}
                onSubmit={(values) => {
                    registerHandeler(values);
                }}
            >
                <Form className={styles.formLogin}>
                    <div className={styles.sectionW}>
                        <div className="main-form-group mb-3">
                            <label className="mian-label">{content.inputGroup1.label}</label>
                            <div className="input-frame input-frame-two">
                                <Field
                                    name="name"
                                    type="text"
                                    placeholder={content.inputGroup1.placeholder}
                                />
                            </div>
                            <ErrorMessage
                                name="name"
                                render={(msg) => (
                                    <div className="main-error">{msg}</div>
                                )}
                            />
                        </div>
                    </div>
                    <div className={styles.sectionW}>
                        <div className="main-form-group mb-3">
                            <label className="mian-label">{content.inputGroup2.label}</label>
                            <div className="input-frame input-frame-two">
                                <Field
                                    name="family"
                                    type="text"
                                    placeholder={content.inputGroup2.placeholder}
                                />
                            </div>
                            <ErrorMessage
                                name="family"
                                render={(msg) => (
                                    <div className="main-error">{msg}</div>
                                )}
                            />
                        </div>
                    </div>
                    <div className={styles.sectionW}>
                        <div className="main-form-group mb-3">
                            <label className="mian-label">{content.inputGroup3.label}</label>
                            <div className="input-frame input-frame-two">
                                <Field
                                    name="phone_number"
                                    type="text"
                                    placeholder={content.inputGroup3.placeholder}
                                />
                            </div>
                            <ErrorMessage
                                name="phone_number"
                                render={(msg) => (
                                    <div className="main-error">{msg}</div>
                                )}
                            />
                        </div>
                    </div>
                    <div className={styles.sectionW}>
                        <div className="main-form-group mb-3">
                            <label className="mian-label">{content.inputGroup4.label}</label>
                            <div className="input-frame input-frame-two">
                                <Field
                                    name="email"
                                    type="text"
                                    placeholder={content.inputGroup4.placeholder}
                                />
                            </div>
                            <ErrorMessage
                                name="email"
                                render={(msg) => (
                                    <div className="main-error">{msg}</div>
                                )}
                            />
                        </div>
                    </div>
                    <div className={styles.sectionW}>
                        <div className="main-form-group mb-3">
                            <label className="mian-label">{content.inputGroup5.label}</label>
                            <div className="input-frame input-frame-two">
                                <Field
                                    name="password"
                                    type="password"
                                    showpasswordinput="true"
                                    placeholder={content.inputGroup5.placeholder}
                                />
                            </div>
                            <ErrorMessage
                                name="password"
                                render={(msg) => (
                                    <div className="main-error">{msg}</div>
                                )}
                            />
                        </div>
                    </div>
                    <div className={styles.sectionW}>
                        <div className="main-form-group mb-3">
                            <label className="mian-label">{content.inputGroup6.label}</label>
                            <div className="input-frame input-frame-two">
                                <Field
                                    name="confirm_password"
                                    showpasswordinput="true"
                                    type="password"
                                    placeholder={content.inputGroup6.placeholder}
                                />
                            </div>
                            <ErrorMessage
                                name="confirm_password"
                                render={(msg) => (
                                    <div className="main-error">{msg}</div>
                                )}
                            />
                        </div>
                    </div>

                    <div className={styles.formLoginBtns}>
                        <button className={styles.formLoginBtnActive}>{content.btn1}</button>
                        <BtnBack text={content.btn2} />
                    </div>

                </Form>

            </Formik>
        </LayoutLogin>
    );
}

export default Register;